"use client";

import { createContext, useContext, useEffect, useState } from "react";

export type UserType = any | null;

type UserContextType = {
  user: UserType;
  setUser: (user: UserType) => void;
};

export const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => {},
});

export const useUser = () => useContext(UserContext);

export function UserContextProvider({
  initialUser,
  children,
}: {
  initialUser: UserType;
  children: React.ReactNode;
}) {
  const [user, setUser] = useState(initialUser);

  useEffect(() => {
    setUser(initialUser);
  }, [initialUser]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}
